import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Box, Text } from '@wix/design-system';
export const StringElement = _ref => {
  let {
    children,
    skin,
    className,
    onClick,
    size,
    light,
    ...boxProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, {
    className: className,
    skin: skin,
    onClick: onClick,
    size: size,
    light: light
  }, /*#__PURE__*/React.createElement(Box, _extends({
    display: "inline-block",
    alignSelf: "center"
  }, boxProps), children));
};
//# sourceMappingURL=StringElement.js.map